import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadLocation } from 'actions/provider';
import Dropdown from 'atoms/dropdown';
import { getServiceNameWithTags, isNotEmptyArray } from 'util';

export default function ServiceSelect({
  animalTypeId,
  animalBreedId,
  animalSizeId,
  selectedService,
  setSelectedService,
}) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [servicesOptions, setServicesOptions] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    setSelectedService({});
    setServicesOptions([]);
    dispatch(loadLocation({ animalTypeId, animalBreedId, animalSizeId })).then(
      ({ success, data }) => {
        if (success) {
          const { services } = data.data;
          const options = services.map((service) => ({
            ...service,
            name: getServiceNameWithTags(service),
          }));
          setServicesOptions(options);
        }
        setIsLoading(false);
      }
    );
  }, [animalTypeId, animalBreedId, animalSizeId]);

  return (
    <div className="service-select-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <div className="flex-row justify-between">
        <h4 className="mb-12">Service</h4>
        <h4 className="mb-12">Cost</h4>
      </div>
      <div className="flex-row justify-between">
        <Dropdown
          placeholder={
            isLoading
              ? 'Loading...'
              : isNotEmptyArray(servicesOptions)
              ? 'Select service'
              : 'No services available'
          }
          className="w-75"
          items={servicesOptions}
          disableDropdown={isLoading || !isNotEmptyArray(servicesOptions)}
          onClick={(service) => setSelectedService(service)}
          value={selectedService}
          size="small"
          noWrap
        />
        <p>
          {selectedService && selectedService.price?.localized
            ? selectedService.price.localized
            : '-'}
        </p>
      </div>
    </div>
  );
}
